module.exports = __webpack_public_path__ + "static/media/handoff-schedule.072a87f6.png";